import { TruckAlertIcon } from './TruckAlertIcon';

/**
 * author: Simran
 * id 8650D94A-71BC-4B6B-9BA9-A6A2A756063C
 * name truck-alert
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/truck-alert.svg
 * tags
 * - Transportation + Road 
 * - Alert / Error 
 */
export const TruckErrorIcon = TruckAlertIcon;
export default TruckErrorIcon